import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Tooltip } from 'react-bootstrap';

/* Function */
import ObjGeneral from '../function/';
import Constants from '../function/constants.js';
/* Local store */
import { localStoreFN } from '../../store/localStorage.js';
/* Actions */
import * as dashboardActions from '../../actions/dashboard/index.js';
import * as driverRoadwarningActions from '../../actions/driver_roadwarning/index';
import * as accountDriverActions from '../../actions/account_driver/index';

/* Components */
import Header from '../../components/driver_roadwarning/header';
import MicrosleepsKpiEvolutionGraph from '../../components/common/roadwarning/microsleepsKpiEvolutionGraph';
import MicrosleepsQuantityEvolutionGraph from '../../components/common/roadwarning/microsleepsQuantityEvolutionGraph';
import DriverWorkshiftsGraph from '../../components/driver_roadwarning/driverWorkshiftsGraph';
import DriverAlertCurveGraph from '../../components/driver_roadwarning/driverAlertCurveGraph';
import TitleMain from '../../components/common/titleMain';
import Label from '../../components/common/label';
import RankingTable from '../../components/common/tables/rankingTable';
import CircularIndicator from '../../components/common/indicators/circularIndicator';
import SimpleIndicator from '../../components/common/indicators/simpleIndicator';
import Avatar from '../../components/common/avatar';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import AvatarImg from '../../../../public/images/nopicture.png';
import Expired from '../expired/index';
import tourConfig from '../../components/common/tour/config';
import tourSteps from '../../components/driver_roadwarning/tourSteps';

class DriverRoadwarning extends Component {
  constructor(props) {
    super(props);
    this.state = {
      driver: 0,
      showAlertGraph: false,
      isTourOpen: false
    };
  }

  componentWillUnmount() {
    this.props.actions.resetDriverRoadWarning();
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('roadwarning');
    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);
        if (obj.generalSetting.views.includes('roadwarning')) {
          const dateStart = this.props.filters.date.fechaStartFinal || null;
          const dateEnd = this.props.filters.date.fechaEndFinal || null;
          const tags = this.props.filters.tags;
          const driver = this.props.filters.driver ? this.props.filters.driver.id : null;
          this.state.driver = driver;

          await this.props.accountDriverActions.fetchAccountDriverApi({
            dateStart,
            dateEnd,
            tags,
            seeFilter: true
          });
          await this.props.actions.fetchDriverRoadwarningApi({
            dateStart,
            dateEnd,
            tags,
            driver: driver
          });
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  handleSubmit = async obj => {
    const format = this.props.language.account.date.format;

    let driver = this.state.driver;
    let driverText = null;
    if (obj.id == 'driver') {
      driver = Number.isInteger(obj.value) ? obj.value : 0;
      if (Number.isInteger(obj.value)) {
        driverText = this.props.accountDriverDatos.find(o => o.id === obj.value);
      } else {
        driverText = null;
      }
      this.setState({ driver: driver });
    }

    /* TAGS */
    const tags = ObjGeneral.getTags(obj);
    /* DATE */
    const date = ObjGeneral.getDate(obj, format);

    this.props.actions.setFilterDriverRoadWarning({
      tags: tags,
      date: date,
      driver: driverText
    });
    await this.props.accountDriverActions.fetchAccountDriverApi({
      seeFilter: true,
      tags: tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal
    });

    await this.props.actions.fetchDriverRoadwarningApi({
      tags: tags,
      dateStart: date.fechaStartFinal,
      dateEnd: date.fechaEndFinal,
      driver: driver
    });
  };

  showAlertGraph = () => {
    var isTourOpen = false;
    const viewedTours = localStoreFN().getItem('viewedTours');
    const tourComplete = viewedTours ? JSON.parse(viewedTours)[Constants.toursKeys.driverRoadWarning] : false;

    if(this.state.showAlertGraph==false 
      && tourComplete==false) {
      isTourOpen = true;
    }

    this.setState({
      showAlertGraph: !this.state.showAlertGraph,
      isTourOpen: isTourOpen
    });
  };

  openTour = () => {
    this.setState({
      isTourOpen: true
    });
  };  

  closeTour = async () => {
    const viewedTours = localStoreFN().getItem('viewedTours');
    const tourComplete = viewedTours ? JSON.parse(viewedTours)[Constants.toursKeys.driverRoadWarning] : false;
    if(tourComplete==false) {
      await this.props.dashboardActions.setTourViewed({tourName:Constants.toursKeys.driverRoadWarning});
    }

    this.setState({
      isTourOpen: false
    });
  };

  componentDidUpdate = (prevProps, prevState) => {
    if(prevState.isTourOpen==false && this.state.isTourOpen==true) {
      tourConfig.openTourJsCall(tourSteps, this.closeTour, this.props.language);
    }
  };

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      const permits = localStoreFN().getItem('permits');
      const alertCurvePermit = permits.includes('alertnessintimeline');
      const setting = ObjGeneral.getSetting({
        setting: obj.driverRoadWarning,
        filter: this.props.filter,
        general: obj.generalSetting
      });
      const { graphColorRange } = obj;
      const language = this.props.language ? this.props.language.filter : '';

      return (
        <section className="main full-height driver-roadwarning">
          <Header
            loadingFilter={this.props.loadingFilter}
            filters={this.props.filters}
            filter={setting.filter}
            date={this.props.dateMax[1]}
            handleSubmit={this.handleSubmit}
            drivers={this.props.accountDriverDatos}
            language={language}
          />
          {this.props.loading || this.props.accountDriverLoading ? (
            <Loading language={this.props.language} />
          ) : this.props.status === 401 ||
            (this.props.statusTags === 401 && this.props.accountDriverStatus == 401) ? (
            <Expired
              history={this.props.history}
              language={this.props.language ? this.props.language : ''}
            />
          ) : this.props.status === 200 &&
            this.props.statusTags === 200 &&
            this.props.accountDriverStatus == 200 ? (
            <div className="main-container">
              <div className="top-row">
                <div className="top-left-section">
                  <div className="vertical-container">
                    <section className="operation-info">
                      <section className="avatar-image-wrapper">
                        <Avatar width={90} src={`${AvatarImg}`} />
                        <Label label={this.props.datos.driverName} />
                      </section>
                      <section className="microsleeps-kpi-wrapper">
                        <CircularIndicator
                          size={130}
                          max={100}
                          value={this.props.datos.warningRate}
                          forceValue={100}
                          fill={true}
                          valueFormat={{ type: 'NUMBER', format: '.1f' }}
                          graphColorRange={graphColorRange.roadWarningRate}
                        />
                        <Label
                          label={this.props.language.driver_roadwarning.labels.microsleepsKpi}
                        />
                      </section>
                    </section>
                  </div>
                </div>
                <div className="top-right-section">
                  <section className="driver-evolution">
                    <TitleMain
                      className={'second'}
                      title={this.props.language.driver_roadwarning.title.evolution}
                    />
                    {this.props.datos.dailyWarningRate.length > 0 && (
                      <MicrosleepsKpiEvolutionGraph
                        data={this.props.datos.dailyWarningRate}
                        graphColorRange={graphColorRange.roadWarningRate}
                        tooltip={this.props.language.driver_roadwarning.labels}
                        language={this.props.language}
                      />
                    )}
                  </section>
                </div>
              </div>
              <div className="middle-row">
                <section className="operation-indicators">
                  <TitleMain
                    className={'second'}
                    title={this.props.language.driver_roadwarning.title.totalEvents}
                  />
                  <section className="operation-indicators-innerwrapper">
                    <div className="indicators-row">
                      <div className="indicators-cell">
                        <SimpleIndicator
                          value={this.props.datos.warningTotal}
                          valueFormat={{ type: 'NUMBER', format: '.0f' }}
                          graphColorRange={graphColorRange.roadWarningQuantity}
                        />
                        <Label
                          label={this.props.language.driver_roadwarning.labels.totalMicrosleeps}
                        />
                      </div>
                    </div>
                    <section className="operation-quantity-evolution">
                      {this.props.datos.dailyTotalWarnings.length > 0 && (
                        <MicrosleepsQuantityEvolutionGraph
                          data={this.props.datos.dailyTotalWarnings}
                          graphColorRange={graphColorRange.roadWarningQuantity}
                          tooltip={this.props.language.driver_roadwarning.labels.evolutionGraphBarTooltip}
                          language={this.props.language}
                        />
                      )}
                    </section>
                  </section>
                </section>
              </div>
              <div className="bottom-row">
                <section className="workshifts-component">
                  <div className="timeline-buttons">
                    {(alertCurvePermit==true 
                      && this.state.driver!=null
                      && this.state.driver!=0) && (
                      <button
                        id="showAlertGraphButton"
                        className="normal_button showAlertGraphButton"
                        onClick={this.showAlertGraph}
                      >
                        {this.props.language.driver_fatigue.buttons.changeView}
                        <i className="fas fa-eye"/>
                      </button>
                    )}
                    {(alertCurvePermit==true 
                      && this.state.driver!=null
                      && this.state.driver!=0
                      && this.state.showAlertGraph) && (
                      <div className="help-buttons">
                        <div className="box-form">
                          <ul className="buttom_menu">
                            <li>
                              <i className="fas fa-question-circle"/>
                              <ul>
                                <li>
                                  <a data-close="ok" onClick={this.openTour}>
                                    {this.props.language.filter.repeatTour}
                                  </a>
                                </li>
                              </ul>
                            </li>
                          </ul>
                        </div>
                      </div>
                    )}
                  </div>
                  { (!this.state.showAlertGraph) ? (
                    <TitleMain
                      className={'second'}
                      title={this.props.language.driver_roadwarning.title.workshifts}
                      info={{
                        text: this.props.language.driver_fatigue.help.workshifts
                      }}
                    />
                  ) : (
                    <TitleMain
                      className={'second'}
                      title={this.props.language.driver_fatigue.title.alertCurve}
                      info={{
                        text:this.props.language.driver_fatigue.help.alertCurve
                      }}
                    />
                  )}
                  {!this.state.showAlertGraph &&
                    this.props.datos.shiftsList &&
                    this.props.datos.shiftsList.length > 0 && (
                    <DriverWorkshiftsGraph
                      microSleep={obj.generalSetting.microSleepTime}
                      data={this.props.datos.shiftsList}
                      graphColorRange={graphColorRange.roadWarningQuantity}
                      tooltip={this.props.language.driver_fatigue.graphToolTip}
                      graphLabels={this.props.language.driver_fatigue.graphEventsLabels}
                      language={this.props.language}
                    />
                  )}
                  {alertCurvePermit==true &&
                    this.state.showAlertGraph &&
                    this.props.datos.alertCurveData &&
                    this.props.datos.alertCurveData.shiftsList &&
                    this.props.datos.alertCurveData.shiftsList.length > 0 && (
                    <DriverAlertCurveGraph
                      microSleep={obj.generalSetting.microSleepTime}
                      data={this.props.datos.alertCurveData.shiftsList}
                      tooltip={this.props.language.driver_fatigue.graphToolTip}
                      graphColorRange={graphColorRange.roadWarningQuantity}
                      graphLabels={this.props.language.driver_fatigue.graphAlertStateLabels}
                      language={this.props.language}
                    />
                  )}
                </section>
              </div>
              <Tooltip className="fatigue-tooltip" placement="top" id="pageTooltip" />
            </div>
          ) : this.props.status === 500 || this.props.statusTags === 500 ? (
            <Message message={this.props.language.error.apiError500} />
          ) : (
            <Message message={this.props.language.error.apiError} />
          )}
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message="NO Setting" />
        </section>
      );
    }
  }
}
const mapStateToProps = state => ({
  filter: state.reducer.tags.filter,
  statusTags: state.reducer.tags.status,
  loadingFilter: state.reducer.tags.loading,

  accountDriverDatos: state.reducer.accountDriver.datos,
  accountDriverStatus: state.reducer.accountDriver.status,
  accountDriverLoading: state.reducer.accountDriver.loading,

  language: state.reducer.dashboard.language,
  dateMax: state.reducer.dashboard.dateMax,
  setting: state.reducer.dashboard.setting,

  datos: state.reducer.driverRoadwarning.datos,
  loading: state.reducer.driverRoadwarning.loading,
  status: state.reducer.driverRoadwarning.status,
  filters: state.reducer.driverRoadwarning.filters
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(driverRoadwarningActions, dispatch),
  accountDriverActions: bindActionCreators(accountDriverActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

DriverRoadwarning.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DriverRoadwarning);



// WEBPACK FOOTER //
// ./source/client/containers/driver_roadwarning/index.jsx